import { StubPage } from '../StubPage'
export function Ingredients() {
  return <StubPage title="Ingredients & Traits" summary="Ingredients are primitive data types (text, number, date, boolean, UUID, email, phone…). Traits combine an Ingredient with a display label, validation rules (min, max, pattern), and an optional identifier flag. Traits are reusable — the same Trait can be added to multiple Cups." />
}
